import {asset} from 'imba';
import url from './lalogo.png';
export default asset({
	url: url,
	type: 'image',
	width: 519,
	height: 314,
	toString: function(){ return this.url;}
})